import { render, staticRenderFns } from "./PercentageAndColorFormatter.vue?vue&type=template&id=6d107dca&functional=true&"
import script from "./PercentageAndColorFormatter.vue?vue&type=script&lang=js&"
export * from "./PercentageAndColorFormatter.vue?vue&type=script&lang=js&"
import style0 from "./PercentageAndColorFormatter.vue?vue&type=style&index=0&id=6d107dca&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports